import {
  ETIQUETA_DE_GRUPO,
  itemDeMenuDe,
  type DefinicionRuta,
  type GrupoNavegacion,
  type Vista,
} from '../../navegacion/rutas.js'

const ORDEN_GRUPOS: readonly GrupoNavegacion[] = ['fiscalizacion', 'circuito', 'administracion']

export interface DestinoNavegacion {
  vista: Vista
  etiqueta: string
  activo: boolean
}

export interface GrupoNavegacionModelo {
  id: GrupoNavegacion
  etiqueta: string
  destinos: readonly DestinoNavegacion[]
  activo: boolean
}

export interface ModeloNavegacion {
  principal: GrupoNavegacionModelo | undefined
  auxiliares: readonly GrupoNavegacionModelo[]
}

/**
 * Convierte el catálogo plano de rutas en la jerarquía visual del sidebar.
 *
 * Fiscalización tiene prioridad; Circuito pasa a ser principal para sus
 * actores y Administración solo ocupa esa posición cuando es la única
 * superficie disponible. La decisión depende de permisos, nunca del rol.
 */
export function construirModeloNavegacion(
  rutas: readonly DefinicionRuta[],
  vistaActiva: Vista,
): ModeloNavegacion {
  const vistaMenuActiva = itemDeMenuDe(vistaActiva) ?? vistaActiva
  const grupos = ORDEN_GRUPOS.flatMap((id): readonly GrupoNavegacionModelo[] => {
    const destinos = rutas
      .filter((ruta) => ruta.grupo === id)
      .map((ruta) => ({
        vista: ruta.vista,
        etiqueta: ruta.etiqueta,
        activo: ruta.vista === vistaMenuActiva,
      }))

    if (destinos.length === 0) return []
    return [{
      id,
      etiqueta: ETIQUETA_DE_GRUPO[id],
      destinos,
      activo: destinos.some((destino) => destino.activo),
    }]
  })

  const principal = grupos.find((grupo) => grupo.id !== 'administracion') ?? grupos[0]
  return {
    principal,
    auxiliares: grupos.filter((grupo) => grupo !== principal),
  }
}
